import { render, staticRenderFns } from "./container.vue?vue&type=template&id=2c4ee2f4&scoped=true&"
import script from "./container.vue?vue&type=script&lang=js&"
export * from "./container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ee2f4",
  null
  
)

export default component.exports